<svelte:options customElement="dst-about-sidebar" />

<script lang="ts">
	import { baseUrls } from '@/config.ts';
	import { register as registerClosables } from '@/lib/closable.ts';
	import { closableInformElement } from '@/stores/header_store.ts';
	import {
		mdiAccountGroup,
		mdiApps,
		mdiAssistant,
		mdiChatOutline,
		mdiChevronRight,
		mdiClose,
		mdiEmailOpenHeartOutline,
		mdiHandshake,
		mdiRadioTower,
		mdiRss,
		mdiSquareRoundedBadgeOutline,
		mdiTimelineTextOutline,
	} from '@mdi/js';
	import { onMount } from 'svelte';

	let root;
	const baseUrl = baseUrls.about_default ?? '';

	onMount(async () => {
		registerClosables(root, $closableInformElement);
	});
</script>

<div class="app--header--sidebar" id="app-sidebar" bind:this={root}>
	<div class="app--header--sidebar--content u-scrollbar">
		<div class="app--header--sidebar--header">
			<h1>Unternehmen</h1>
			<button type="button" title="Menü ausblenden" data-closable-target="app-sidebar">
				<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path fill="currentColor" d={mdiClose} />
				</svg>
			</button>
		</div>
		<nav aria-label="Haupt-Navigation">
			<ul>
				<slot name="search" />
				<li>
					<a href="{baseUrl}/">
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path fill="currentColor" d={mdiApps} />
						</svg>
						Startseite
					</a>
				</li>
				<li>
					<a href="{baseUrl}/geschichte">
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path fill="currentColor" d={mdiTimelineTextOutline} />
						</svg>
						Geschichte
					</a>
				</li>
				<li>
					<a href="{baseUrl}/unternehmen">
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path fill="currentColor" d={mdiAccountGroup} />
						</svg>
						Unternehmen
					</a>
				</li>
				<li>
					<a href="{baseUrl}/so-arbeiten-wir">
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path fill="currentColor" d={mdiHandshake} />
						</svg>
						So arbeiten wir
					</a>
				</li>
				<li>
					<a href="{baseUrl}/aktuelles">
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path fill="currentColor" d={mdiChatOutline} />
						</svg>
						Aktuelles
					</a>
				</li>
				<li>
					<details open>
						<summary>
							<div>
								<span>Services</span>
								<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
									<path fill="currentColor" d={mdiChevronRight} />
								</svg>
							</div>
						</summary>
						<ul>
							<li>
								<a href="{baseUrl}/services/newsletter">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiEmailOpenHeartOutline} />
									</svg>
									Newsletter abonnieren
								</a>
							</li>
							<li>
								<a href="{baseUrl}/services/push-notifications">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiSquareRoundedBadgeOutline} />
									</svg>
									Push Notifications
								</a>
							</li>
							<li>
								<a href="{baseUrl}/services/rss-feeds">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiRss} />
									</svg>
									RSS Feeds
								</a>
							</li>
							<li>
								<a href="{baseUrl}/services/radionachrichten">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiRadioTower} />
									</svg>
									Radionachrichten
								</a>
							</li>
							<li>
								<a href="{baseUrl}/services/google-home">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiAssistant} />
									</svg>
									Google Home Action
								</a>
							</li>
						</ul>
					</details>
				</li>
				<li>
					<details open>
						<summary>
							<div>
								<span>Redaktion</span>
								<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
									<path fill="currentColor" d={mdiChevronRight} />
								</svg>
							</div>
						</summary>
						<ul class="compact">
							<li>
								<a href="{baseUrl}/redaktion/blattlinie"> Blattlinie </a>
							</li>
							<li>
								<a href="{baseUrl}/redaktion/leitlinie"> Leitlinien Unabhängigkeit </a>
							</li>
							<li>
								<a href="{baseUrl}/redaktion/magazine"> Magazine </a>
							</li>
							<li>
								<a href="{baseUrl}/redaktion/schwerpunktausgaben"> Schwerpunktausgaben </a>
							</li>
							<li>
								<a href="{baseUrl}/redaktion/wochenschwerpunkte"> Wochenschwerpunkte </a>
							</li>
							<li>
								<a href="{baseUrl}/redaktion/redaktionelles-impressum"> Redaktionelles Impressum </a>
							</li>
							<li>
								<a href="{baseUrl}/redaktion/redaktionsstatut/"> Redaktionsstatut </a>
							</li>
							<li>
								<a href="{baseUrl}/redaktion/journalistisches-praktikum"> Journalistisches Praktikum </a>
							</li>
						</ul>
					</details>
				</li>
				<li>
					<ul class="compact">
						<li>
							<a href="{baseUrl}/b2b"> Business-to-Business (B2B) </a>
						</li>
						<li>
							<a href="{baseUrl}/impressum"> Impressum </a>
						</li>
						<li>
							<a href="{baseUrl}/kontakt"> Kontakt </a>
						</li>
						<li>
							<a href="{baseUrl}/offenlegung"> Offenlegung </a>
						</li>
						<li>
							<a href="{baseUrl}/agb"> Allgemeine Geschäftsbedingungen </a>
						</li>
						<li>
							<a href="{baseUrl}/nutzungsbedingungen"> Nutzungsbedingungen </a>
						</li>
					</ul>
				</li>
			</ul>
		</nav>
	</div>
	<div class="app--header--sidebar--backdrop" data-closable-target="app-sidebar" />
</div>

<style lang="scss" global>
	@use '../../scss/DstSidebar.scss';
</style>
